/**
 * Capitalizes the first letter of a given string.
 * @param string - The string to capitalize.
 */
export default function capitalize(string: string){
    return string[0].toUpperCase() + string.slice(1)
}

/**
 * Cleans a string by removing underscores, equal signs, and extra spaces,
 * and capitalizes the first letter.
 * @param str - The string to clean.
 * @return The cleaned and capitalized string.
 */
export function cleanText(str: string): string {
    const cleaned = str
      .replace(/_/g, ' ')
      .replace(/=/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

/**
 * Removes colons from a string.
 * @param str - The string from which to remove colons.
 * @return The string with all colons removed.
 */
export function removeColon(str: string): string {
    return str.replace(/:/g, '');
}

export function formatTextWithLinks(text: string): string {
  // handle URLs
  return text.replace(/\[(https?:\/\/[^\[\]]+)]/g, (match, url) => {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });
}

export function normalizeMacAddress(mac?: string): string {
  if (!mac) return '';
  // Remove all non-hex characters, then re-insert colons
  const hex = mac.replace(/[^a-fA-F0-9]/g, '').toUpperCase();
  return hex.match(/.{1,2}/g)?.join('-') ?? '';
}